import { Editable } from "./editable.model";

export class Income extends Editable {
    /** Unique internal identity of the income. */
    public id: number;

    /** Unique internal identity of the contact associated with the income. */
    public contactId: number;

    /** Unique string of the income type associated with the income. */
    public type: string;

    /** The amount of income received per month. */
    public value: number;

    /** Indicates whether or not the income is the primary one for the contact. */
    public primary: boolean;

    /** Date and time the income was created. */
    public createdAt: Date;

    /** Date and time the income was modified. */
    public updatedAt: Date;
}